import { render } from "./RimborsoDetail.vue?vue&type=template&id=abc73e12&scoped=true"
import script from "./RimborsoDetail.vue?vue&type=script&lang=js"
export * from "./RimborsoDetail.vue?vue&type=script&lang=js"

import "./RimborsoDetail.vue?vue&type=style&index=0&id=abc73e12&scoped=true&lang=css"

import exportComponent from "/Users/andrea/Sites/app_v2/app_mmx/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-abc73e12"]])

export default __exports__